import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UserServiceProvider } from '../service/user-service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css']
})

export class IndexComponent implements OnInit {

    // variable que guarda elnumero decedula
    cedula:any;

    //variable para saber si hay estudiantes
    estud: number;

    /**
     * variable para desabilitar el boton de guardar mientra se esta enviando el formulario 
     * */
    buttonStatus: boolean;

    // Variable que recibe respuesta del listado completo de estudiantes
    fullResponse: any;
    constructor(
        private userServiceProvider: UserServiceProvider,
        private translate: TranslateService,
        private toastr: ToastrService
    ) {
        this.buttonStatus = false;
     }

    ngOnInit() {
    }

    buscar() {
        if (this.cedula) {
            this.buttonStatus = true;
        this.userServiceProvider
        .getStudiante(this.cedula)
        .subscribe(response => {
            console.log('response ==>', response);
           this.fullResponse = response;
            if (this.fullResponse) {
                this.estud = 1;
                this.buttonStatus = false;
            } else {
                this.estud = 0;
                this.buttonStatus = false;
            }
        });
        } else {
            this.showSuccess();
        }
    }

    showSuccess() {
        this.toastr.warning('Por favor ingrese el Número de Cédula', 'BUSCAR ');
      }
}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/index/index.component.ts